<div
  *ngIf="showContent; else headerLoader"
  class="table-header"
  [ngStyle]="{ 'grid-template-columns': gridSize }"
  prlwResponsive
>
  <prlw-last-deals-table-header
    *ngFor="let column of columns"
    [column]="column"
    [sorting]="sorting"
    (click)="sortColumn.emit(column.id)"
    data-cy="table-column-header"
  ></prlw-last-deals-table-header>
</div>

<ng-template #headerLoader>
  <div class="loader-plug-wrapper loader-plug-wrapper--header">
    <div class="loader-plug loader-plug--basis"></div>
    <div class="loader-plug"></div>
  </div>
</ng-template>
